export default "__VITE_ASSET__AHQA8CWH__"